module.exports = __webpack_public_path__ + "img/home_cover.2fec4091.jpg";